import { MobileWarningModal } from '@/components/Elements/MobileWarningModal/MobileWarningModal';
import { UpgradeModal } from '@/components/UpgradeModal';
import { ForceLoginState } from '@/providers/ForceLoginState';
import { Outlet } from 'react-router';

export const PrivateApp = () => {
  return (
    <ForceLoginState type="loggedInOnly">
      <MobileWarningModal />
      <UpgradeModal />
      <Outlet />
    </ForceLoginState>
  );
};
